import Image from 'next/image';
import React from 'react';

import FloatingCards from '@/components/FloatingCards';
import { MarkdownContent } from '@/components/v4/MarkdownContent';
import { ShopProps } from '@/pages/solucoes-de-pagamentos-digitais';
import { BannerCardProps } from '@/types/cms';

import Features, { FeaturesProps } from './components/Features';
import { Container, Divider, LogoContainer, TextContainer } from './styles';

interface PagarmeProps
  extends Omit<ShopProps['bannerCards'], 'id' | 'referId' | 'bannerCards'> {
  id: string;
  title: string;
  subTitle: string;
  cards: BannerCardProps[];
  features: FeaturesProps;
}

const Pagarme: React.FC<PagarmeProps> = ({
  id,
  title,
  subTitle,
  cards,
  features,
}) => {
  return (
    <Container
      id={id}
      colorType="display"
      colorValue="50"
      backgroundBorderRadius="120px 0px 0px 0px"
      backgroundBorderRadiusSmall="60px 0px 0px 0px"
    >
      <LogoContainer>
        <Image
          src="e-commerce/pagarme/logo-pagarme"
          width="268"
          height="96"
          alt="PagarMe"
        />
      </LogoContainer>
      <TextContainer>
        <MarkdownContent content={title} className="text-center heading-1" />
        <h4>{subTitle}</h4>
      </TextContainer>
      <>
        <Divider />
        {cards.length > 0 && (
          <FloatingCards cards={cards} isBorder isReverse={false} />
        )}
        <>
          <Divider />
          <Features cards={features} />
        </>
      </>
    </Container>
  );
};

export default Pagarme;
